import { createAsyncThunk } from '@reduxjs/toolkit';
import type { 
  SearchSettlementsRequest, 
  SearchSettlementsResponse,
  CommissionSumRequest,
  CommissionSumResponse,
  CommissionSearchRequest,
  CommissionSearchResponse,
  TransactionSearchRequest,
  TransactionSearchResponse,
} from '../Domain/entity/SettlementTypes';
import { settlementUseCases } from './settlementUseCases';

/**
 * Settlement 검색 (POST /settlement/m/sch)
 */
export const searchSettlements = createAsyncThunk<
  SearchSettlementsResponse, 
  SearchSettlementsRequest, 
  { rejectValue: string }
>(
  'settlement/searchSettlements',
  async (request, { rejectWithValue }) => {
    try {
      return await settlementUseCases.searchSettlements.execute(request);
    } catch (error) {
      return rejectWithValue((error as Error).message ?? 'Settlement 검색 실패');
    }
  }
);

/**
 * 후원금 내역 합계 (POST /mgmtcommission/m/sum)
 */
export const getCommissionSum = createAsyncThunk<
  CommissionSumResponse,
  CommissionSumRequest,
  { rejectValue: string }
>(
  'settlement/getCommissionSum',
  async (request, { rejectWithValue }) => {
    try {
      return await settlementUseCases.getCommissionSum.execute(request);
    } catch (error) {
      return rejectWithValue((error as Error).message ?? '후원금 내역 합계 조회 실패');
    }
  }
);

/**
 * 후원금 내역 조회 (POST /mgmtcommission/m/sch)
 */
export const searchCommissions = createAsyncThunk<
  CommissionSearchResponse,
  CommissionSearchRequest,
  { rejectValue: string }
>(
  'settlement/searchCommissions',
  async (request, { rejectWithValue }) => {
    try {
      return await settlementUseCases.searchCommissions.execute(request);
    } catch (error) {
      return rejectWithValue((error as Error).message ?? '후원금 내역 조회 실패');
    }
  }
);

/**
 * 후원 신청(거래) 조회 (POST /transactions/m/sch)
 */
export const searchTransactions = createAsyncThunk<
  TransactionSearchResponse,
  TransactionSearchRequest,
  { rejectValue: string }
>(
  'settlement/searchTransactions',
  async (request, { rejectWithValue }) => {
    try {
      return await settlementUseCases.searchTransactions.execute(request);
    } catch (error) {
      return rejectWithValue((error as Error).message ?? '후원자 목록 조회 실패');
    }
  }
);

